import { render, staticRenderFns } from "./ViewDetailGeneral.vue?vue&type=template&id=0718a944&scoped=true&"
import script from "./ViewDetailGeneral.vue?vue&type=script&lang=js&"
export * from "./ViewDetailGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailGeneral.vue?vue&type=style&index=0&id=0718a944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0718a944",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow,VSpacer})
